import { apis } from '@/config';
import { api } from '@/api/api';
class MailPraiseApiImpl {
    constructor() {
        this.contactApi = api.requireLogicalApi(apis.contactApiImpl);
        this.name = apis.mailPraiseApiImpl;
        this.systemApi = api.getSystemApi();
        this.http = api.getDataTransApi();
    }
    init() {
        return this.name;
    }
    afterLoadFinish() {
        return this.name;
    }
    initCurrentUserPendantId() {
        var _a;
        const currentUser = this.systemApi.getCurrentUser();
        const accountId = (_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.contact) === null || _a === void 0 ? void 0 : _a.contact.id;
        if (accountId) {
            this.getPersonMedalDetail(accountId);
        }
    }
    setCurrentUserPendantId(id) {
        this.systemApi.setUserProp('pendantId', String(id));
    }
    async handlePromise(promise, handleData) {
        try {
            const res = await promise;
            const data = res.data;
            return this.getCommonRes(data, handleData);
        }
        catch (e) {
            return {
                success: false,
            };
        }
    }
    getCommonRes(resData, handleData) {
        if (resData === null || resData === void 0 ? void 0 : resData.success) {
            let { data } = resData;
            if (handleData) {
                data = handleData(data);
            }
            return {
                data,
                success: true,
            };
        }
        return {
            success: false,
            message: resData === null || resData === void 0 ? void 0 : resData.message,
        };
    }
    setMedalPendant(id) {
        const url = this.systemApi.getUrl('setPendant');
        return this.handlePromise(this.http.post(url, { id }, { contentType: 'json' }));
    }
    cancelMedalPendant(id) {
        const url = this.systemApi.getUrl('cancelPendant');
        return this.handlePromise(this.http.post(url, { id }, { contentType: 'json' }));
    }
    getMedals() {
        const url = this.systemApi.getUrl('getMedals');
        return this.handlePromise(this.http.get(url));
    }
    async getPersonMedalDetail(accountId) {
        var _a;
        const url = this.systemApi.getUrl('getPersonMedalDetail');
        const res = await this.handlePromise(this.http.get(url, { accountId }));
        const { pendantImageUrl: avatarPendant = '', id: pendantId = -1 } = ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.medals.find(medal => medal.asPendant)) || {};
        this.setCurrentUserPendantId(pendantId);
        this.contactApi.doUpdateContactById({ id: accountId, avatarPendant });
        return res;
    }
}
const mailPraiseApiImpl = new MailPraiseApiImpl();
api.registerLogicalApi(mailPraiseApiImpl);
export default mailPraiseApiImpl;
